import { ReactElement } from 'react'

import CreateCaminhaoImpl from 'modules/caminhao/domain/usecases/CreateCaminhao'
import FindCaminhaoByDescricaoImpl from 'modules/caminhao/domain/usecases/FindCaminhaoByDescricao'
import ICaminhaoRepository from 'modules/caminhao/infra/repositories/CaminhaoRepository'
import FindAll from 'modules/tipoCaminhao/domain/usecases/FindAll'
import ITipoCaminhaoRepository from 'modules/tipoCaminhao/infra/repositories/TipoCaminhaoRepository'
import ListVeiculosImpl from 'modules/veiculos/domain/usecases/ListVeiculosImpl'
import IVeiculosRepository from 'modules/veiculos/infra/repositories/VeiculosRepository'

import CreateCaminhao from '../../pages/Register'

export const RegisterCaminhaoFactory = (): ReactElement => {
  const tipoCaminhaoRepository = new ITipoCaminhaoRepository()
  const findAll = new FindAll(tipoCaminhaoRepository)

  const caminhaoRepository = new ICaminhaoRepository()
  const findCaminhaoByDescricaoImpl = new FindCaminhaoByDescricaoImpl(
    caminhaoRepository,
  )
  const createCaminhaoImpl = new CreateCaminhaoImpl(caminhaoRepository)

  const veiculosRepository = new IVeiculosRepository()
  const listVeiculosImp = new ListVeiculosImpl(veiculosRepository)

  return (
    <CreateCaminhao
      findAll={findAll}
      findCaminhaoByDescricao={findCaminhaoByDescricaoImpl}
      listVeiculos={listVeiculosImp}
      createCaminhao={createCaminhaoImpl}
    />
  )
}
